import deleteWithToken from './base/delete-with-token'

const customerDeleteLinkItem = (id) => deleteWithToken(`/customer-link/${id}`)()

export default customerDeleteLinkItem